import { components } from 'react-select'

import type { ReactElement } from 'react'
import type { OptionProps } from 'react-select'

import UserCard from '~/components/UserCard'
import { capitalize } from '~/utils/string'

interface OptionData {
  label: string
  userData: {
    job: string
    name: string
    picture: string
  }
  value: string
}

const CustomOption = (props: OptionProps): ReactElement => {
  const { className, cx, data, innerProps, innerRef, isDisabled, isFocused, isSelected } = props

  const { userData } = data as OptionData

  return userData ? (
    <div
      className={cx(
        {
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      <UserCard name={capitalize(userData.name)} picture={userData.picture} size="medium" subInfo={userData.job} />
    </div>
  ) : (
    <components.Option {...props} />
  )
}

export default CustomOption
